module.exports = __webpack_public_path__ + "img/ico-twitter.cc26cd15.svg";